import { render, staticRenderFns } from "./SupplierSizeDeviations.vue?vue&type=template&id=1822ece0"
import script from "./SupplierSizeDeviations.ts?vue&type=script&lang=ts&external"
export * from "./SupplierSizeDeviations.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports